export default __webpack_public_path__ + "static/media/Abhishek Singh.3fdb13f9.pdf";